import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TopBarComponent } from './top-bar.component';
import { I18nModule } from 'src/app/core/languages-support/i18n.module';
import { AppSupportedLanguages } from 'src/app/core/languages-support/i18n-config.service';

@NgModule({
  declarations: [
    TopBarComponent,
  ],
  imports: [
    CommonModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatSelectModule,
    MatToolbarModule,
    MatFormFieldModule,
    FormsModule,
    I18nModule.forRoot(AppSupportedLanguages),
  ],
  exports: [
    TopBarComponent,
  ],
})
export class TopBarModule { }
